//
//
//
//
//
//
//
//
// import Header from './components/Header'
import MainTain from './components/Main';
export default {
  name: 'bhxc',
  components: {
    MainTain: MainTain
  }
};